module.exports = __webpack_public_path__ + "static/media/7.367c6d5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/minsk/7.jpg
// module id = 233
// module chunks = 0